import { render, staticRenderFns } from "./NavigationDrawerCobrancaMensalista.vue?vue&type=template&id=3dd0db8a&scoped=true&"
import script from "./NavigationDrawerCobrancaMensalista.vue?vue&type=script&lang=ts&"
export * from "./NavigationDrawerCobrancaMensalista.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationDrawerCobrancaMensalista.vue?vue&type=style&index=0&id=3dd0db8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd0db8a",
  null
  
)

export default component.exports